import { PageContent } from "../../config/routes/content";

export const getPageContent = (content: { [key: string]: PageContent }, routeLabel: string): PageContent | undefined => {
	return content?.[routeLabel];
};
